<template>
  <div class="pb-6 px-6 pt-0" style="width: 100%;">
    <CreateProductForm :state="dialog" :types="types" @closeDialog="close" @refresh="getProducts" />
    <div class=" py-6 d-flex" style="width: 100%">
      <div class="component-title">Hệ đào tạo</div>
    </div>
    <div class="d-flex justify-end align-center mb-6">
      <!-- <v-btn color="primary" class="elevation-0 ml-6" dark>
        <v-icon left>mdi-format-list-bulleted-type</v-icon> Tạo phân loại
      </v-btn> -->
      <v-btn color="primary" class="elevation-0 ml-6" dark @click="openCreate">
        <v-icon left>mdi-package-variant-closed</v-icon>Thêm hệ đào tạo</v-btn
      >
    </div>
    <!-- <v-card class="pa-6 elevation-1  mb-6">
      <ProductFilter @onFilterChanged="onFilterChanged" />
    </v-card> -->

    <v-card class="elevation-1">
      <ProductTable :products="products" ref="activeCodeTable" />
    </v-card>
  </div>
</template>

<script>
import {mapActions} from 'vuex'
import ProductTable from './ProductTable.vue'
import CreateProductForm from './CreateProductForm.vue'
// import ProductFilter from './ProductFilter.vue'

export default {
  components: {
    ProductTable,
    CreateProductForm
    // ProductFilter
  },
  data() {
    return {
      dialog: false,
      types: [],
      products: []
    }
  },
  async created() {
    this.$loading.active = true
    await this.getProducts({})
    await this.getTypes()
    this.$loading.active = false
  },
  methods: {
    ...mapActions('product', ['fetchProducts', 'fetchProductTypes']),
    async getProducts(query) {
      this.$loading.active = true
      const prods = await this.fetchProducts({...query})
      this.products = prods
      this.$loading.active = false
    },
    async getTypes() {
      this.types = await this.fetchProductTypes({})
    },
    openCreate() {
      this.dialog = true
    },
    close() {
      this.dialog = false
    }
  }
}
</script>

<style scoped>
.component-title {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 28px;
  color: #0d47a1;
}
</style>
